import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTieredStopCharge extends Layout {
    sourceTieredCharge: DataSource;
    textboxAmount: Textbox;
    textboxChargeCode: Textbox;
    textboxChargeType: Textbox;
    textboxDescr: Textbox;
    textboxNumberOfStops: Textbox;
}
